import { NavLink, useLocation } from "react-router-dom";
import ItodoImage from "../../elements/itodo-img";
import { useState, useEffect } from "react";
import { loadScript } from "../../../globals/constants";
import ContactForm from "../../components/contactus/ContactForm";

function Header1() {
    const [isActive, setIsActive] = useState(false);
    const location = useLocation();

    const toggleNavClass = () => {
        setIsActive(!isActive);
    };

    const handleMobileNavClick = () => {
        if (window.innerWidth <= 991) {
            setIsActive(false);
        }
    };

    const isActiveRoute = (path) => location.pathname === path;

    useEffect(() => {
        loadScript("js/mobilenav.js");

        // Close mobile nav on outside click
        const handleOutsideClick = (e) => {
            const navMenu = document.querySelector(".header-nav");
            const toggleButton = document.getElementById("mobile-side-drawer");

            if (
                isActive &&
                window.innerWidth <= 991 &&
                navMenu &&
                !navMenu.contains(e.target) &&
                toggleButton &&
                !toggleButton.contains(e.target)
            ) {
                setIsActive(false);
            }
        };

        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [isActive]);

    return (
        <header className={`header-style1 site-header mobile-sider-drawer-menu ${isActive ? "active" : ""}`}>
            <div className="sticky-header main-bar-wraper navbar-expand-lg flex">
                <div className="main-bar">
                    <div className="container d-flex justify-content-between align-items-center">
                        {/* Left: Logo */}
                        <div className="logo-header">
                            <div className="logo-header-inner logo-header-one">
                                <NavLink to="/" onClick={handleMobileNavClick}>
                                    <ItodoImage src="images/Logo.png" alt="Azown Technology’s logo" />
                                </NavLink>
                            </div>
                        </div>

                        {/* Center: Navigation */}
                        <div className="d-flex align-items-center">
                            {/* Toggle for mobile */}
                            <button
                                id="mobile-side-drawer"
                                data-target=".header-nav"
                                data-toggle="collapse"
                                className="navbar-toggler collapsed"
                                onClick={toggleNavClass}
                            >
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar icon-bar-first" />
                                <span className="icon-bar icon-bar-two" />
                                <span className="icon-bar icon-bar-three" />
                            </button>

                            {/* Navigation Menu */}
                            <div className="header-nav navbar-collapse collapse d-flex justify-content-center">
                                <ul className="nav navbar-nav">
                                    <li className={isActiveRoute("/") ? "active" : ""}>
                                        <NavLink to="/" onClick={handleMobileNavClick}>Home</NavLink>
                                    </li>
                                    <li className={isActiveRoute("/about-us") ? "active" : ""}>
                                        <NavLink to="/about-us" onClick={handleMobileNavClick}>Company</NavLink>
                                        <ul className="sub-menu">
                                            <li><NavLink to="/about-us" onClick={handleMobileNavClick}>About Azown</NavLink></li>
                                            <li><NavLink to="/team" onClick={handleMobileNavClick}>Team</NavLink></li>
                                            <li><NavLink to="/" onClick={handleMobileNavClick}>Blogs</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className={isActiveRoute("/government") ? "active" : ""}>
                                        <NavLink to="/government" onClick={handleMobileNavClick}>Government</NavLink>
                                    </li>
                                    <li className={isActiveRoute("/services") ? "active" : ""}>
                                        <NavLink to="/services" onClick={handleMobileNavClick}>Services</NavLink>
                                        <ul className="sub-menu">
                                            <li><NavLink to="/digital-marketing" onClick={handleMobileNavClick}>Digital Marketing</NavLink></li>
                                            <li><NavLink to="/web-devlopment" onClick={handleMobileNavClick}>Web Development</NavLink></li>
                                            <li><NavLink to="/content-creation" onClick={handleMobileNavClick}>Content Creation</NavLink></li>
                                            <li><NavLink to="/graphic-design" onClick={handleMobileNavClick}>Graphic Design</NavLink></li>
                                            <li><NavLink to="/video-production" onClick={handleMobileNavClick}>Video Production</NavLink></li>
                                            <li><NavLink to="/social-media" onClick={handleMobileNavClick}>Edit & Post Production</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className={isActiveRoute("/portfolio") ? "active" : ""}>
                                        <NavLink to="/portfolio" onClick={handleMobileNavClick}>Portfolio</NavLink>
                                    </li>
                                    <li className={isActiveRoute("/contact-us") ? "active" : ""}>
                                        <NavLink to="/contact-us" onClick={handleMobileNavClick}>Contact Us</NavLink>
                                    </li>
                                </ul>
                            </div>
                            
                        </div>

                        {/* Right: Enquiry Button */}
                        <div className="d-none d-lg-block">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header1;
